import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const COLOR_MAP = {
  teal: { bg: "bg-teal-600", text: "text-white" },
  red: { bg: "bg-red-600", text: "text-white" },
  green: { bg: "bg-emerald-600", text: "text-white" },
  blue: { bg: "bg-blue-600", text: "text-white" },
};

export default function TickerBar() {
  const [tickers, setTickers] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/tickers").then((r) => setTickers(r.data)).catch(() => {});
  }, []);

  if (dismissed || tickers.length === 0) return null;

  const first = tickers[0];
  const colors = COLOR_MAP[first.color] || COLOR_MAP.teal;

  return (
    <div
      className={`${colors.bg} ${colors.text} relative overflow-hidden`}
      data-testid="ticker-bar"
    >
      <div className="max-w-7xl mx-auto px-4 flex items-center py-2 text-sm">
        <div className="flex-1 overflow-hidden">
          <div className="ticker-scroll flex items-center gap-12 whitespace-nowrap">
            {tickers.map((t, i) => (
              <span key={t.id || i} className="inline-flex items-center gap-2">
                <span>{t.text}</span>
                {t.link_url && (
                  <Link
                    to={t.link_url}
                    className="underline underline-offset-2 font-semibold hover:opacity-80"
                    data-testid={`ticker-link-${i}`}
                  >
                    {t.link_text || "Learn more"}
                  </Link>
                )}
              </span>
            ))}
            {/* Duplicate for seamless loop */}
            {tickers.map((t, i) => (
              <span key={`dup-${t.id || i}`} className="inline-flex items-center gap-2">
                <span>{t.text}</span>
                {t.link_url && (
                  <Link
                    to={t.link_url}
                    className="underline underline-offset-2 font-semibold hover:opacity-80"
                  >
                    {t.link_text || "Learn more"}
                  </Link>
                )}
              </span>
            ))}
          </div>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="ml-3 shrink-0 p-1 rounded hover:bg-white/20 transition-colors"
          data-testid="ticker-dismiss"
          aria-label="Dismiss announcement"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
